export default __webpack_public_path__ + "static/media/HASCOL.1f690147.png";